var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.135 13.75c2.845 0 5.152-2.351 5.152-5.251 0-2.9-2.307-5.251-5.152-5.251-2.846 0-5.153 2.35-5.153 5.25s2.307 5.251 5.153 5.251zm0 1c3.388 0 6.134-2.8 6.134-6.251 0-3.453-2.746-6.251-6.134-6.251C3.747 2.248 1 5.046 1 8.498c0 3.453 2.747 6.252 6.135 6.252zM13.104 4.554a7.199 7.199 0 0 0-2.755-2.522l.444-.892a8.187 8.187 0 0 1 3.134 2.868l-.823.546z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.796 8.503c0-2.624-2.088-4.75-4.662-4.75h-.246v4.75l4.21 2.5a4.796 4.796 0 0 0 .698-2.5z",
    fill: "#F8B028"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.396 1.752h.982v1h-.982v-1zM4.926.75h3.926v1H4.926v-1z",
    fill: "#4A4A4A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClock);
export default __webpack_public_path__ + "static/media/time_clock.b2bfeb102268afe7dfdbda2696b354ff.svg";
export { ForwardRef as ReactComponent };